<template>
    <b-card
        title=""
        :class="['lx-card', nested && 'lx-card-nested']"
        :header-class="[...headerClass]"
        no-body
    >
        <template #header>
            <span class="card-header-icon">
                <slot name="header-icon"></slot>
            </span>
            <span
                :class="['card-header-content', ...headerContentClass, hasIcon]"
                ><slot name="header-content"></slot
            ></span>
        </template>
        <b-card-body
            v-if="$slots.body"
            :style="[scrollable && height && `height: ${height}px`]"
            :class="[
                'card-body',
                ...bodyClass,
                scrollable && 'lx-card-scrollable',
            ]"
        >
            <slot name="body"></slot>
        </b-card-body>
    </b-card>
</template>

<script>
    export default {
        name: 'Card',
        props: {
            bodyClass: {
                type: Array,
                default: () => [],
            },
            headerClass: {
                type: Array,
                default: () => [],
            },
            headerContentClass: {
                type: Array,
                default: () => [],
            },
            nested: {
                type: Boolean,
                default: false,
            },
            scrollable: {
                type: Boolean,
                default: false,
            },
            height: {
                type: Number,
                default: null,
            },
        },
        computed: {
            hasIcon() {
                return !!this.$slots['header-icon'] ? 'has-icon' : '';
            },
        },
    };
</script>

<style lang="scss" scoped>
    .lx-card {
        .lx-card-nested {
            border: 0;
            margin-left: -1.5rem;
            margin-right: -1.5rem;

            > :deep(.card-header) {
                border-radius: 0px !important;
            }
        }

        .lx-card-scrollable {
            overflow-y: scroll;
        }

        > :deep(.card-header) {
            background-color: #0d47a1 !important;
            color: #fff;
            align-items: center;
            padding: 0 !important;
            justify-content: left !important;
            min-height: 50px;
        }

        > :deep(.card-body) {
            padding: 1.5rem !important;
        }

        .card-header-icon {
            font-size: 16px;
            margin-left: 1.5rem;
        }

        .card-header-content {
            font-size: 16px;
            font-weight: bold;
            &.has-icon {
                padding-left: 10px !important;
            }
        }
    }
</style>
